export default __webpack_public_path__ + "static/media/secret_pay.76e33e16.svg";